import React from 'react';
import type { ReactPlayerProps } from 'react-player';
import { useInView } from 'react-intersection-observer';
import Image from '../../primitives/image';
import Spinner from '../../primitives/spinner';
import { colors } from '../../primitives/colors';

const PlayerImport = React.lazy(() => import('react-player'));

const VideoPlayer = ({ className, style, thumbnail, background, ...props }: ReactPlayerProps): JSX.Element => {
    const [shouldInitiate, setShouldInitiate] = React.useState<boolean>(false);
    const { ref: inViewRef, inView } = useInView();

    React.useEffect(() => {
        let timeout: NodeJS.Timeout | undefined;
        if (inView) {
            timeout = setTimeout(() => {
                setShouldInitiate(true);
            }, 300);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [inView]);

    return (
        <div
            role="presentation"
            ref={inViewRef}
            className={className}
            style={style}
        >
            <Image
                image={thumbnail}
                css={{
                    backgroundColor: background || colors.shadesBlack,
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                }}
            />
            {!thumbnail && (
                <div css={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    left: '0',
                    top: '0',
                    color: colors.shadesWhite,
                }}
                >
                    <Spinner />
                </div>
            )}
            {shouldInitiate && (
                <React.Suspense fallback={<div />}>
                    <PlayerImport style={{ zIndex: 1, position: 'relative' }} {...props} />
                </React.Suspense>
            )}
        </div>
    );
};

export default VideoPlayer;
